export const ErrorPage: React.FC<{
  actions: React.ReactNode;
  errorMessage: string;
  header?: string;
  type?: "error-account" | "error" | "notice";
}> = ({
  actions,
  errorMessage,
  header = "Oops, something has gone wrong",
  type = "error",
}) => {
  return (
    <div className="flex h-full flex-col items-center justify-center">
      <p className="mb-6 border-stroke-line border-b pb-4 text-sm">{header}</p>
      {type === "notice" && (
        <img className="h-[18.75rem] w-[18.75rem]" src={"/images/bird.png"} />
      )}
      {type === "error" && (
        <img
          className="h-[18.75rem] w-[18.75rem]"
          src={"/images/jellyfish.png"}
        />
      )}
      {type === "error-account" && (
        <img
          className="h-[18.75rem] w-[18.75rem]"
          src={"/images/dragonfly.png"}
        />
      )}
      <pre className="mb-6 w-[50rem] whitespace-break-spaces text-center">
        {errorMessage}
      </pre>
      <div className="flex items-center gap-2">{actions}</div>
    </div>
  );
};
